<template>
  <div>
    <v-list-tile ripple 
      v-bind:key="agentInfos.status"
      :id="'agent_' + agentInfos.agentID"
      class="itemsListeAgent"
    >
      <v-badge overlap v-if="sessionsChatAgent.length" color="green" left>
        <template v-slot:badge>
          <span>{{sessionsChatAgent.length}}</span>
        </template>
        <wz-avatar :src="agentInfos.avatar" :username="agentInfos.agentName" size="38px" :class="agentInfos.status" style="border-radius: 50%; padding: 2px;"></wz-avatar>
      </v-badge>
      <wz-avatar v-else :src="agentInfos.avatar" :username="agentInfos.agentName" size="38px" :class="agentInfos.status" style="border-radius: 50%; padding: 2px;"></wz-avatar>

      <v-list-tile-content class="wz_truncate listeAgentName">
        <v-list-tile-title>{{agentInfos.agentName}}</v-list-tile-title>
        <v-list-tile-sub-title>{{agentInfos.jobAgent}}</v-list-tile-sub-title>
      </v-list-tile-content>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-show="
              agentInfos.status === 'online' &&
              $store.getters['_User/account'].role === 'super' &&
              agentInfos.socketID !== '1'
            "
            v-bind="attrs"
            v-on="on"
            @click="showDialogConfirm = true"
            flat
            icon
            color="pink"
          >
            <v-icon>person_off</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('btnAgentOffline') }}</span>
      </v-tooltip>
    </v-list-tile>

    <v-dialog
      v-model="showDialogConfirm"
      persistent
      max-width="490"
    >
      <wz-dialog-confirm
        :titleDialogConfirm="$t('titelConfirmOffline')"
        :contentDialogConfirm="'<strong>' + agentInfos.agentName + '</strong>' + $t('textConfirmOffline') " 
        @closeDialogConfirm="justCloseDialogConfirm"
        @justCloseDialogConfirm="justCloseDialogConfirm"
        @submitDialogConfirm="switchToStatus('offline')"
      ></wz-dialog-confirm>
    </v-dialog>
  </div>
</template>

<style>
.offline {background-color: #ef4f4f;}
.online {background-color: #1cde7b;}
.busy {background-color: #e6c628;}
.listeAgentName{margin-left: 6px;}
.v-expansion-panel__header {padding: 6px 0px 6px 0px;}
.v-expansion-panel__container--active{background-color: #e5e5e5;}
</style>

<script>
// import _ from 'lodash'
import { mapGetters, mapState, mapMutations } from 'vuex'
import _watcheebox from './watcheebox.js'
import { DOMAINE } from '../../constants'

export default {
  props: ['datasAgent'], // Les donnés du parent (trafic.vue)
  data () {
    return {
      showDialogConfirm: false
    }
  },

  mounted () {
  },

  methods: {
    ...mapMutations('_StoreWatcheeBox', ['SET_STATUS_MANUALLY']),
    switchToStatus (status) {
      _watcheebox.changeStatusAgent({
        statut: status,
        agentID: this.agentInfos.agentID,
        sessionsPrivees: this.agentInfos.chatSessions,
        roomName: this.agentInfos.roomName,
        socket: this.$socket,
        sessionPHP: this.agentInfos.sessionPHP
      })
      // Sauve en Session le status choisi manuellement
      this.SET_STATUS_MANUALLY(status)
      this.showDialogConfirm = false
    },
    justCloseDialogConfirm () {
      this.showDialogConfirm = false
      this.messageResDialog = ''
    }
  },

  watch: {
  },

  computed: {
    ...mapGetters('_StoreWatcheeBox', ['WATCHEEBOX_STATE', 'sessionsPrivees']),
    ...mapState('_StoreWatcheeBox', ['listeChatAgent', 'sessionsPrivees']),
    ...mapGetters('_User', ['user', 'account']),
    agentInfos () {
      // retourne la bonne url de l'image avatar
      var avatarURL = ''
      if (process.env.NODE_ENV === 'development') {
        avatarURL = `${DOMAINE}/dev/media/user/small/${this.datasAgent[7]}`
      } else {
        avatarURL = `${DOMAINE}/media/user/small/${this.datasAgent[7]}`
      }
      console.log('this.datasAgent', this.datasAgent)
      return {
        // donnés remontées par redis via nodejs
        'roomName': this.datasAgent[0],
        'agentName': this.datasAgent[1],
        'agentID': this.datasAgent[2],
        'status': this.datasAgent[3],
        'socketID': this.datasAgent[4],
        'conversations': this.datasAgent[5],
        'jobAgent': this.datasAgent[6],
        'avatar': avatarURL, // url de l'avatar
        'siteID': this.datasAgent[9],
        'entrepriseID': this.datasAgent[10],
        'licences': this.datasAgent[11],
        'chatSessions': this.datasAgent[12],
        'deviceAgent': this.datasAgent[13],
        'tokenFB': this.datasAgent[14],
        'pageFB': this.datasAgent[15],
        'focusAgent': this.datasAgent[16],
        'focusSessionChat': this.datasAgent[17],
        'priority': this.datasAgent[18],
        'keywords': this.datasAgent[19],
        'cobrowsingSessionActive': this.datasAgent[20],
        'sessionPHP': this.datasAgent[22]
      }
    },
    sessionsChatAgent () {
      // filtre les chat avec le bon id agent
      // console.log('listeChatAgent', this.listeChatAgent)
      // console.log('this.datasAgent[2]', this.datasAgent[2])
      // return _.filter(this.listeChatAgent, [3, this.datasAgent[2]])
      return this.listeChatAgent.filter(chat => chat[3] === this.datasAgent[2])
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/watcheebox/WzWatcheeboxAgent.vue